import { useQuery } from '@tanstack/react-query';

import { getCountries } from './countries';

const COUNTRIES_KEY = 'Countries';

export const useGetCountries = () => {
  const { data, ...restProps } = useQuery({
    queryKey: [COUNTRIES_KEY],
    queryFn: getCountries,
  });

  return { data, ...restProps };
};
